import { render, staticRenderFns } from "./IssueCategoryForm.vue?vue&type=template&id=7b24b2a4&"
import script from "./IssueCategoryForm.vue?vue&type=script&lang=js&"
export * from "./IssueCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports